import WordService from "@/services/WordService";
import { root } from "@/common/consts";

const actions = {
    loadThesaurus({ commit }, data) {
        commit("RESET_THESAURUS_FLAG");

        WordService.getThesaurus(data.slug)
            .then(response => {
                const { audio, pronunciation, headword, slug, thesaurus } = response;
                const related = Object.values(thesaurus.related);
                const synonymStudies = Object.values(thesaurus.synonymStudies);
                let synonyms = [];
                let posFilters = [];
                let categoryFilters = [];
                let study = [];

                related.forEach(i => {
                    synonyms.push(i);
                    posFilters.push(i.partOfSpeech);
                    categoryFilters.push(i.type);
                });

                synonymStudies.forEach(i => {
                    study.push(i);
                });

                commit("SET_AUDIO_DATA", {
                    audio,
                    pronunciation: pronunciation ? pronunciation.replace(/&stress;/gim, "'") : ""
                });
                commit("SET_THESAURUS_HEADWORD", headword || slug);
                commit("SET_THESAURUS", synonyms);
                commit("SET_DEFAULT_FILTERS", {
                    pos: posFilters,
                    category: categoryFilters
                });
                commit("SET_SYNONYM_STUDIES", study);
            })
            // eslint-disable-next-line no-unused-vars
            .catch(err => {
                // Add meta tag with property robots=noindex
                const firstMeta = document.getElementsByTagName("meta")[0];
                const metaRobots = document.createElement("meta");
                metaRobots.setAttribute("name", "robots");
                metaRobots.setAttribute("content", "noindex");
                firstMeta.parentNode.insertBefore(metaRobots, firstMeta);

                if (typeof window.__PRERENDER_INJECTED !== "undefined") {
                    window.document.dispatchEvent(
                        new CustomEvent("spa-render-404", {
                            detail: { component: data.component }
                        })
                    );
                    return;
                }

                /**
                 * Eject the user to the 404 No Results page
                 * if we don't have results for this word
                 */
                window.location.assign(`${root.THESAURUS}/404/no-results`);
            });
    },
    toggleMobileFilterPanel({ commit }, opened = false) {
        commit("TOGGLE_MOBILE_FILTER", opened);
    },
    filterThesaurus({ commit, dispatch, state }, obj) {
        commit("SET_ACTIVE_FILTERS", obj);
        commit("FILTER_THESAURUS");

        dispatch("orderThesaurusBy", state.orderSelected);
    },
    orderThesaurusBy({ commit }, obj) {
        switch (obj) {
            case "votes":
                commit("SORT_BY_VOTES_THESAURUS");
                break;
            case "relevance":
                commit("SORT_BY_RELEVANCE");
                break;
            case "a-z":
                commit("SORT_AZ_THESAURUS");
                break;
            case "z-a":
                commit("SORT_ZA_THESAURUS");
                break;
            default:
                break;
        }
    },
    clearActiveFilters({ commit }) {
        commit("CLEAR_ACTIVE_FILTERS");
    },
    // sortedThesaurus is not use while MultiSortingOption is live
    sortedThesaurus({ commit, state }, isSorted) {
        commit("SET_IS_SORTED", isSorted);

        if (state.isSorted) {
            commit("SORT_AZ_THESAURUS");
        } else {
            // commit("SORT_BY_REVELANCE");
            commit("SET_THESAURUS", state.thesaurus);
            commit("FILTER_THESAURUS");
        }
    },
    copySynonym({ commit }, synonym) {
        commit("SET_COPIED_SYNONYM", synonym);
    }
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/ThesaurusFilter/actions.js